<script>
import {ref} from "vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";

export default {
  name: "WebPage",
  components: {LoadingPage},

  setup() {

    let loading = ref(false)

    let weblogs = ref([])

    function get_weblogs() {

      loading.value = true
      FreeWorld.Heisenberg({}, 'blog').then((res) => {

        loading.value = false

        weblogs.value = res.data

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_weblogs)
      })

    }

    get_weblogs()

    return {
      weblogs,
      loading,
    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':'' " class="bg-main">

    <div class="div-top-arrow bg-color d-flex align-items-center">
      <div class="d-flex align-items-center">
        <p class="m-0 font-4">
          وبلاگ ها
        </p>
        <div onclick="window.history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>

    <div class="p-body mt-3 parent animate__animated animate__fadeIn">

      <router-link v-for="item in weblogs" :key="item.id" :to="{name:'DetailsBlog' , params:{bid:item.id}}"
           class="bg-white p-3 rounded-4 overflow-hidden text-decoration-none item d-flex flex-column mx-1 mb-3">
          <span class="animated-background img_item rounded-4 mb-3">
          <img class="w-100 img_item rounded-3" :src="item.pic1" alt="" loading="lazy">
          </span>

        <p class="rounded-4 font-5 font-bold overflow-hidden mb-2">
          <span :class="{'txtoverflow':item.title.length > 28}">{{ item.title }}</span>
        </p>

        <p class="rounded-4 font-5 item_content overflow-hidden m-0 mb-3">{{ item.content }}</p>

        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <img style="width: 1.2rem;height: 1.2rem" class="" src="../assets/img/blog-_1_.svg" alt="">

            <p class="m-0 font-6 me-1">{{ item.source }}</p>
          </div>

          <div class="d-flex align-items-center">
            <img style="width: 1.2rem;height: 1.2rem" class="" src="../assets/img/icon_calendar_.svg" alt="">

            <p class="m-0 font-6 me-1">{{ item.date }}</p>
          </div>
        </div>
      </router-link>

    </div>


  </div>

  <div id="web" :class="loading ? 'activeClass':'' " class="bg-main">

    <NavbarPage></NavbarPage>

    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 my-4 w-75 ma-auto">وبلاگ ها</div>

    <div class="p-4 bg-white parent rounded-4 m-auto w-75">

      <router-link v-for="item in weblogs" :key="item.id" :to="{name:'DetailsBlog' , params:{bid:item.id}}"
                   class="bg-costom shadow p-3 rounded-4 overflow-hidden text-black text-decoration-none item d-flex flex-column mx-1 mb-3">
          <span class="animated-background img_item rounded-4 mb-3">
          <img class="w-100 img_item rounded-3" :src="item.pic1" alt="" loading="lazy">
          </span>

        <p class="rounded-4 font-5 font-bold overflow-hidden mb-2">
          <span :class="{'txtoverflow':item.title.length > 28}">{{ item.title }}</span>
        </p>

        <p class="rounded-4 font-5 item_content overflow-hidden m-0 mb-3">{{ item.content }}</p>

        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <img style="width: 1.2rem;height: 1.2rem" class="" src="../assets/img/blog-_1_.svg" alt="">

            <p class="m-0 font-6 me-1">{{ item.source }}</p>
          </div>

          <div class="d-flex align-items-center">
            <img style="width: 1.2rem;height: 1.2rem" class="" src="../assets/img/icon_calendar_.svg" alt="">

            <p class="m-0 font-6 me-1">{{ item.date }}</p>
          </div>
        </div>
      </router-link>

    </div>


    <FooterPage></FooterPage>
  </div>

</template>


<style scoped>

.parent {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
}

@media (min-width: 900px) {
  .img_item {
    height: 18rem !important;
  }
}

@media (min-width: 600px) and (max-width: 899px) {
  .img_item {
    height: 15rem !important;
  }
}

.item {
  flex-grow: 0;
  flex-basis: 48%;
}

.img_item {
  height: 12rem;
}

.item_content {
  height: 4.5rem;
  overflow: hidden;
  color: #575757;
}

</style>
